import { configureStore } from "@reduxjs/toolkit";
import productReducer from "../features/product/redux/ProductList.slice";
import productDetailsReducer from "../features/ProductDetail/redux/productDetailsSlice";
import cartReducer from "../features/cart/redux/cartSlice";

export const store = configureStore({
  reducer: {

   product: productReducer,
   productDetails: productDetailsReducer,
  cart: cartReducer,
  },
});
export default store;